import { BaseFilter, Entity, SchoolContentSectionType } from '@axl/accel-framework/models';
import { observable, action } from 'mobx';

export class SchoolContentSearchItem extends Entity {
    constructor(item?: Partial<SchoolContentSearchItem>) {
        super(item);
        if (item) this.update(item);
    }

    @observable snippet: string;

    static fromJson(json: any): SchoolContentSearchItem {
        return new SchoolContentSearchItem({
            id: json.id,
            snippet: json.snippet
        });
    }

    @action
    update(changes: Partial<SchoolContentSearchItem>) {
        super.update(changes);
    }
}

export class SchoolContentSearchFilter extends BaseFilter<SchoolContentSearchItem> {
    constructor(filter?: Partial<SchoolContentSearchFilter>) {
        super();
        if (filter) this.update(filter);
    }

    sectionType: SchoolContentSectionType;
    studentCourseId: string;
    libraryId: string;

    update(changes: Partial<SchoolContentSearchFilter>) {
        super.update(changes);
    }
}
